import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { from, interval, merge, Observable, timer, zip } from "rxjs";
import {
    delay,
    distinctUntilChanged,
    map,
    refCount,
    share,
    shareReplay,
    switchMap,
} from "rxjs/operators";

import {
    GetCartTotalsQuery,
    GetActiveCustomerQuery,
} from "../../../common/generated-types";
import { DataService } from "../../providers/data/data.service";
import { StateService } from "../../providers/state/state.service";
import { GET_ACTIVE_CUSTOMER } from "../../../common/graphql/documents.graphql";

import { GET_CART_TOTALS } from "./cart-toggle.graphql";

@Component({
    selector: "vsf-cart-toggle",
    templateUrl: "./cart-toggle.component.html",
    styleUrls: ["./cart-toggle.component.scss"],
})
export class CartToggleComponent implements OnInit {
    @Output() toggle = new EventEmitter<void>();
    cart$: Observable<{ total: number; quantity: number }>;
    cartChangeIndication$: Observable<boolean>;
    activeCustomer$: Observable<GetActiveCustomerQuery["activeCustomer"]>;

    constructor(
        private dataService: DataService,
        private stateService: StateService
    ) {}

    ngOnInit() {
        const getActiveCustomer$ =
            this.dataService.query<GetActiveCustomerQuery>(
                GET_ACTIVE_CUSTOMER,
                {},
                "network-only"
            );

        this.activeCustomer$ = this.stateService
            .select((state) => state.signedIn)
            .pipe(
                switchMap(() => getActiveCustomer$),
                map((data) => data && data.activeCustomer)
            );

        this.cart$ = merge(
            this.stateService.select((state) => state.activeOrderId),
            this.stateService.select((state) => state.signedIn)
        ).pipe(
            switchMap(() =>
                this.dataService.query<GetCartTotalsQuery>(
                    GET_CART_TOTALS,
                    {},
                    "network-only"
                )
            ),
            map(({ activeOrder }) => {
                return {
                    total: activeOrder ? activeOrder.totalWithTax : 0,
                    quantity: activeOrder ? activeOrder.totalQuantity : 0,
                };
            }),
            shareReplay(1)
        );
        this.cartChangeIndication$ = this.cart$.pipe(
            map((cart) => cart.quantity),
            distinctUntilChanged(),
            switchMap(() =>
                zip(from([true, false]), timer(0, 1000), (val) => val)
            )
        );
    }
}
